import React from 'react';
import PatientDashboardHeader from './PatientDashboardHeader';
import PatientDashboardSideMenu from './PatientDashboardSideMenu';

const PatientDashboardLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="hidden md:flex flex-col w-64 bg-white border-r border-gray-200 shadow-lg rounded-none p-0">
        <PatientDashboardSideMenu />
      </aside>
      {/* Main Area */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Topbar */}
        <header className="sticky top-0 z-30 bg-white shadow-sm border-b border-gray-200 rounded-none">
          <PatientDashboardHeader />
        </header>
        {/* Main Content */}
        <main className="flex-1 p-6 md:p-10 bg-gray-50">
          {children}
        </main>
      </div>
    </div>
  );
};

export default PatientDashboardLayout; 